import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Airline } from '../../models/airline.model';
import { KeyValuePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { ProviderStatusClassesPipe } from '../../pipes/provider-status-classes.pipe';
import { ProviderStatusTextPipe } from '../../pipes/provider-status-text.pipe';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-providers',
  imports: [
    KeyValuePipe,
    NgForOf,
    NgClass,
    ProviderStatusClassesPipe,
    ProviderStatusTextPipe,
    NgIf,
    NgxSpinnerModule,
  ],
  templateUrl: './providers.component.html',
  styleUrl: './providers.component.scss',
})
export class ProvidersComponent implements OnInit {
  airlines: { [code: string]: Airline } = {};
  hoveredKey: string | null = null;
  loaded: boolean = false;

  constructor(
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getAirlines();
  }

  getAirlines(): void {
    this.loaded = false;
    this.spinner.show();

    this.apiService
      .getAirlines()
      .pipe(
        finalize(() => {
          this.loaded = true;
          this.spinner.hide();
        })
      )
      .subscribe({
        next: data => {
          this.airlines = data;
        },
        error: error => {
          console.error('Failed to load airlines:', error);
        },
      });
  }

  toggleProvider(code: string): void {
    const current = this.airlines[code];
    this.airlines[code] = {
      ...current,
      active: !current.active,
    };

    this.apiService.updateAirlines(this.airlines).subscribe({
      next: res => {
        this.toastr.success(res.message, 'Success');
      },
      error: err => {
        console.error('Failed to update airline:', err);
        this.toastr.error('Failed to update airline', 'Error');
      },
    });
  }
}
